// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Skeleton$MuiLab from "rescript-material-ui-lab/src/Skeleton.bs.js";
import * as Lab from "@material-ui/lab";

function App_Skeleton(Props) {
  var animationOpt = Props.animation;
  var height = Props.height;
  var width = Props.width;
  var id = Props.id;
  var children = Props.children;
  var classes = Props.classes;
  var className = Props.className;
  var component = Props.component;
  var variant = Props.variant;
  var style = Props.style;
  var animation = animationOpt !== undefined ? animationOpt : /* Wave */0;
  var tmp;
  switch (animation) {
    case /* Wave */0 :
        tmp = Skeleton$MuiLab.Animation.wave;
        break;
    case /* Pulse */1 :
        tmp = Skeleton$MuiLab.Animation.pulse;
        break;
    case /* False */2 :
        tmp = Skeleton$MuiLab.Animation.$$false;
        break;
    
  }
  var tmp$1 = {
    animation: tmp
  };
  if (children !== undefined) {
    tmp$1.children = Caml_option.valFromOption(children);
  }
  if (classes !== undefined) {
    tmp$1.classes = Caml_option.valFromOption(classes);
  }
  if (className !== undefined) {
    tmp$1.className = className;
  }
  if (component !== undefined) {
    tmp$1.component = Caml_option.valFromOption(component);
  }
  var tmp$2 = Belt_Option.mapWithDefault(height, undefined, (function (x) {
          return Caml_option.some(x);
        }));
  if (tmp$2 !== undefined) {
    tmp$1.height = Caml_option.valFromOption(tmp$2);
  }
  if (variant !== undefined) {
    tmp$1.variant = Caml_option.valFromOption(variant);
  }
  var tmp$3 = Belt_Option.mapWithDefault(width, undefined, (function (x) {
          return Caml_option.some(x);
        }));
  if (tmp$3 !== undefined) {
    tmp$1.width = Caml_option.valFromOption(tmp$3);
  }
  if (id !== undefined) {
    tmp$1.id = id;
  }
  if (style !== undefined) {
    tmp$1.style = Caml_option.valFromOption(style);
  }
  return React.createElement(Lab.Skeleton, tmp$1);
}

var make = App_Skeleton;

export {
  make ,
}
/* react Not a pure module */
